import { Actor, Engine, Vector } from "excalibur";
import { ResourcePerTurnComponent } from "../ecs/resources";
import { TargetableComponent } from "../ecs/target";
import { TileComponent } from "../ecs/tile";
import { TowerAnimations } from "../resources";
import { CardKind, CardLevel, Playable, DynamicResources } from "../types";
import { actorName } from "../utils/actor";
import { buildingName } from "../utils/building";

export class PreviewBuilding extends Actor {
  kind: CardKind;
  level: CardLevel;
  matchName: string;
  playable: Playable;
  private _resourceDelta?: DynamicResources;

  constructor({
    tilePos,
    playable,
    resourceDelta,
    buildChain,
  }: {
    tilePos: Vector;
    playable: Playable;
    resourceDelta?: DynamicResources;
    buildChain: string[];
  }) {
    const matchName = buildingName(playable.kind, playable.level);

    super({
      name: actorName(`${matchName}_preview`),
      width: 32,
      height: 32,
      z: 999, // Above regular buildings but below UI
      pos: tilePos,
    });

    this.playable = playable;
    this.kind = playable.kind;
    this.level = playable.level;
    this.matchName = matchName;

    // Store resourceDelta for use in onInitialize
    this._resourceDelta = resourceDelta;
    // Add resource production component based on the delta (if provided) or playable resources
    this.addComponent(
      new ResourcePerTurnComponent(
        [...buildChain, this.playable.label].join(" -> "),
        this._resourceDelta || this.playable.resources,
        false,
      ),
    );
  }

  override onInitialize(_engine: Engine) {
    // Set up graphics with semi-transparency
    const towerGraphic =
      TowerAnimations[
        this.matchName as keyof typeof TowerAnimations
      ].idle.clone();
    towerGraphic.opacity = 0.7;
    this.graphics.use(towerGraphic);

    // Center on tile
    const tileCenter = this.scene?.tileMaps[0].getTile(
      this.pos.x,
      this.pos.y,
    )?.center;
    if (tileCenter) {
      this.pos.setTo(tileCenter.x, tileCenter.y);
    }

    // Add targetable component for hover detection
    this.addComponent(
      new TargetableComponent(this.id, this.name, this.matchName),
    );
    this.addComponent(new TileComponent());
  }
}
